export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  matchCount: number;
}

export const categories: Category[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '覆盖英超、西甲、意甲、德甲、法甲等五大联赛及欧冠、世界杯等全球顶级足球赛事',
    matchCount: 1280,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等全球篮球赛事全覆盖，实时数据同步更新',
    matchCount: 860,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-football-line',
    description: 'ATP、WTA巡回赛及四大满贯赛事全程覆盖，精准实时比分与赔率',
    matchCount: 540,
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: '英雄联盟、DOTA2、CS:GO、王者荣耀等顶级电竞赛事全覆盖',
    matchCount: 720,
  },
  {
    slug: 'others',
    name: '综合',
    icon: 'ri-medal-line',
    description: '乒乓球、羽毛球、排球、橄榄球、拳击等更多精彩体育赛事',
    matchCount: 460,
  },
];